/**
 * Message line for the team group settings screens and overlays. A notice
 * stays on screen until the user dismisses it or their next action replaces
 * it - there's no timer, so nobody misses a server rejection they need to act
 * on (WCAG 2.2.1). Errors go in a role="alert" region and confirmations in a
 * role="status" region so screen readers announce them without moving focus
 * (WCAG 4.1.3). The regions are always rendered, because some screen readers
 * only announce changes to a live region that was already on the page.
 * @param {object|null} notice { text, isError } or null for no message
 * @param {function} onDismiss called when the user dismisses the message
 */
const Notice = ({ notice, onDismiss }) => {

    const message = notice && (
        <p className={'settings-notice ' + (notice.isError ? 'settings-notice--error' : 'settings-notice--success')}>
            <span>{notice.text}</span>
            {onDismiss &&
                <button type='button' className='settings-notice__dismiss'
                    aria-label='Dismiss message' title='Dismiss message' onClick={onDismiss} >
                    &times;
                </button>
            }
        </p>
    );

    return <>
        <div role='alert'>{notice?.isError && message}</div>
        <div role='status'>{notice && !notice.isError && message}</div>
    </>;
};

export default Notice;
